import { UserInfoModel } from '@/core/models/models';
import { AccountService } from '@/core/service/account.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { Badge } from "primeng/badge";


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  imports: [CardModule, CommonModule, Badge],
})
export class ProfileComponent implements OnInit {
  user!: UserInfoModel;

  constructor(private accountService: AccountService) { }

  ngOnInit(): void {
    this.accountService.identity().subscribe(user => {
      this.user = user;
    });
  }

  getRoleName(role: string): string {
    switch (role) {
      case 'ROLE_USER':
        return 'Utente';
      case 'ROLE_ADMIN':
        return 'Amministratore';
      default:
        return '';
    }
  }

}
